<div *ngIf="loading" class="loading-screen-wrapper">
  <div class="loading-screen-icon">
    <mat-spinner></mat-spinner>
    <span *ngIf="textLoading">{{ 'k003851' | translate }}</span>
    <!-- Token: Estamos procesando tu información -->
  </div>
</div>
